import angular, { IOnInit, ITimeoutService } from "angular";
import { chunk, cloneDeep, sortBy } from "lodash";
import { AuthorityGroup, Role } from "../../../model/authorityGroup";
import { UserInfo } from "../../../../application/UserProfile";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { $confirm } from "../../../../../@custom_types/confirm";

export class UserDetailRolesComponentController implements IOnInit {
  static $inject = ["$timeout", ServerUtilityName, "$confirm"];

  private readonly roles: Role[] = [];
  private authorityGroups!: AuthorityGroup[];
  private readonly user!: UserInfo;

  constructor(
    private readonly $timeout: ITimeoutService,
    private readonly serverUtility: ServerUtility,
    private readonly $confirm: $confirm
  ) {}

  $onInit() {
    this.authorityGroups = this.authorityGroups.map((g) => {
      const roles = sortBy(
        //do a clone deep so we don't keep mutating the same role objects
        cloneDeep(this.roles.filter((r) => r.AuthorityGroupId == g.Id)),
        [(r) => r.RoleName]
      );
      return {
        Name: g.Name,
        Id: g.Id,
        Roles: roles,
        ChunkedRoles: chunk(roles, 4),
      };
    });

    //for some reason, need to do this after the toggles have loaded otherwise the
    //UI may not show the correct value of the model
    this.$timeout(0).then(() => {
      this.authorityGroups.forEach((ag) =>
        ag.Roles.forEach((r) => {
          r.UserRole = !!this.user.Roles.find(
            (ur) => ur.RoleName === r.RoleName
          );
        })
      );
    });
  }

  userRoleChanged(role: Role, hasRole: boolean) {
    this.serverUtility
      .sendApiRequest({
        method: hasRole ? "post" : "delete",
        url: `/api/user/${this.user.UserAuthId}/roles`,
        data: {
          RoleId: role.Id,
        },
      })
      .catch((error) => {
        const { data } = error;
        const { Message } = data?.ResponseStatus;
        role.UserRole = !hasRole;
        this.$confirm({
          text: Message ?? "Unknown error occurred",
        });
      });
  }
}
